<section class="welcome-page">
    <div class="welcome-center">
        <div class="alert alert-info text text-blue">
            <h3 class="welcome-title">{{ 'Welcome_Title' | translate }}</h3>
        </div>
        <h4>{{ 'Welcome_Subtitle' | translate }}</h4>
        <div class="domain-box">{{ 'Welcome_DomainLabel' | translate }}: <a href="{{ webDomain() }}">{{ webDomain()
                }}</a></div>
        <p class="mx-5">
            {{ 'Welcome_body' | translate }}
            <br>
            <a href="{{adminUrl()}}">{{ adminUrl() }}</a>
        </p>
    </div>

</section>